import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=bb827cfa&scoped=true&"
import script from "./Drawer.vue?vue&type=script&lang=js&"
export * from "./Drawer.vue?vue&type=script&lang=js&"
import style0 from "./Drawer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Drawer.vue?vue&type=style&index=1&id=bb827cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb827cfa",
  null
  
)

export default component.exports